module.exports = __webpack_public_path__ + "static/img/sk_fdo.266ba39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conversion/testimonial/sk_fdo.png
// module id = jAdf
// module chunks = 35